<template>
  <of-dialog
    :isConfirm="isConfirm"
    @onCancel="cancel"
    @onConfirm="confirm"
    style="margin-top: 10%"
    :appendToBody="true"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="审核意见：" prop="ApprovalOpinions">
          <el-input
            placeholder="审核意见"
            type="textarea"
            v-model="dataForm.ApprovalOpinions"
            clearable
            :rows="8"
          ></el-input>
        </el-form-item>
        <el-form-item label="缴费通知单：" v-if="isTrain&&!isRejected">
          <of-upload
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar, .png, .jpg, .jpeg"
            class="upload-demo"
            list-type="fileList"
            @onUpLoad="onFileUpLoad"
            @onRemove="onFileRemove"
            @onCheckFile="onCheckFile"
            @onPreview="onFilePreview"
            :limit="1"
            :fileList="fileList"
            :class="{ hideFile: hideFile }"
          >
            <div slot="content">
              <el-button size="mini">
                <i class="el-icon-upload el-icon--left"></i>上传文件
              </el-button>
            </div>
          </of-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { saveAs } from "file-saver";
export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    isTrain: {
      type: Boolean,
      default: false
    },
    isRejected: {
      type: Boolean,
      default: true
    }
  },
  components: {
    OfDialog,
    OfUpload
  },
  data() {
    const filevalidate = (rule, value, callback) => {
      if (this.dataForm.PayContentFile === null) {
        callback(new Error('请上传缴费通知单'))
      } else {
        callback()
      }
    }
    return {
      editFormRules: {
        ApprovalOpinions: [
          { required: true, message: "审批信息不能空", trigger: "blur" },
        ],
        PayContetntFile: [
          { required: true, validator: filevalidate, trigger: "change" }
        ]
      },
      isConfirm: false,
      fileList: [],
      hideFile: false
    };
  },
  mounted() {
  },
  methods: {

    onFileUpLoad(file) {
      if (file.response.Code === 0) {
        const list = { name: file.name, url: '/files' + file.response.Data.StorePath };
        this.fileList.push(list);
        this.dataForm.PayContentFile = '/files' + file.response.Data.StorePath
        this.hideFile = true;
        this.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    onFileRemove() {
      this.fileList = [];
      this.dataForm.PayContentFile = null;
      this.hideFile = false;
    },
    onCheckFile(file, status) {
      let size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          type: "error",
          message: "附件大小必须小于10M",
        });
        status(false);
        return;
      }
    },
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
    //取消
    cancel() {
      let that = this;
      that.$emit("formCallBack", null);
    },
    //提交
    confirm() {
      let that = this;
      // if (that.isTrain) {
      //   if(that.dataForm.PayContentFile === '' || that.dataForm.PayContentFile === undefined) {
      //     that.$message({type: "error",message: '请上传缴费单'})
      //     return false
      //   }
      // }
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          that.$emit("onConfirm", that.dataForm);
        }
      });
      that.isConfirm = false;
    },
  },
};
</script>
<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--picture-card {
  width: 217px !important;
  height: 120px !important;
}
.hidePic >>> .el-upload-list__item {
  width: 217px !important;
  height: 120px !important;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>